<template>
    <div>
        <el-form-item label="">
            <el-tooltip placement="top" effect="light">
                <div slot="content">
                    <img src="/static/help/newsletter.png" alt="">
                </div>
                <el-button type="info" size="mini">
                    <i class="fa fa-question-circle"></i> Pomocnicze informacje dotyczące grafik
                </el-button>
            </el-tooltip>
        </el-form-item>
        <el-form-item label="Kolor tła"
                      :error="errors['bg_color']">
            <el-color-picker v-model="form.bg_color"/>
        </el-form-item>
        <el-form-item label="Kolor tekstu"
                      :error="errors['text_color']">
            <el-color-picker v-model="form.text_color"/>
        </el-form-item>
        <el-form-item label="Lewy obrazek"
                      :error="errors['left_image']">
            <image-input-component v-model="form.left_image"/>
        </el-form-item>
        <el-form-item label="Prawy obrazek"
                      :error="errors['right_image']">
            <image-input-component v-model="form.right_image"/>
        </el-form-item>
        <el-form-item label="Opis"
                      :error="errors[addLanguageSuffix('description')]">
            <wyswig-input v-model="form[addLanguageSuffix('description')]"/>
        </el-form-item>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors']
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// NewsletterWidget.vue?6b24b8ce